import React from 'react';
import { useTranslation } from 'react-i18next';

import { normalizeNaming } from 'utils/commonNormalizer';
import { INullable } from 'utils/types';

export enum DICTIONARY_TYPE {
  ANALYTICS = 'analyticsDictionaries',
  AUTH = 'authDictionaries',
  BUILDER = 'builderDictionaries',
  PAYMENT = 'dictionaries',
}

interface IUseGetDictionaryNaming {
  dictionaryType?: DICTIONARY_TYPE;
  disableNormalize?: boolean;
}

export const useGetDictionaryNaming = ({
  dictionaryType = DICTIONARY_TYPE.PAYMENT,
  disableNormalize,
}: IUseGetDictionaryNaming = {}) => {
  const { i18n, t } = useTranslation();

  return React.useCallback(
    (key: string, value?: INullable<string>): string => {
      if (!value) {
        return '-';
      }
      const name = `${dictionaryType}.${key}.${value}` as never;
      const getNormalName = () => {
        return disableNormalize ? value : normalizeNaming(value);
      };
      return i18n.exists(name) ? t(name) : getNormalName();
    },
    [disableNormalize, i18n, dictionaryType, t],
  );
};
